import { render, staticRenderFns } from "./MenuTooltip.vue?vue&type=template&id=5bd61e2c&scoped=true&"
import script from "./MenuTooltip.vue?vue&type=script&lang=js&"
export * from "./MenuTooltip.vue?vue&type=script&lang=js&"
import style0 from "./MenuTooltip.vue?vue&type=style&index=0&id=5bd61e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd61e2c",
  null
  
)

export default component.exports